/* eslint-disable no-unreachable */
import {
  emoji0,
  emoji1,
  emoji2,
  emoji3,
  emoji4,
  smallEmoji1,
  smallEmoji2,
  smallEmoji3,
  smallEmoji4
} from 'assets/images/CreditScore'

const EmojiSelector = ({ score, className = '', size = 'BIG' }) => {
  const classes = `z-2 row-start-1 row-end-2 col-start-1 col-end-2 ${className}`

  switch (score) {
    case 0:
      return <img src={emoji0} className={classes} alt='' />
    case 1:
      return (
        <img
          src={size === 'BIG' ? emoji1 : smallEmoji1}
          className={classes}
          alt=''
        />
      )
    case 2:
      return (
        <img
          src={size === 'BIG' ? emoji2 : smallEmoji2}
          className={classes}
          alt=''
        />
      )
    case 3:
      return (
        <img
          src={size === 'BIG' ? emoji3 : smallEmoji3}
          className={classes}
          alt=''
        />
      )
    case 4:
      return (
        <img
          src={size === 'BIG' ? emoji4 : smallEmoji4}
          className={classes}
          alt=''
        />
      )
    default:
      return null
  }
}

export default EmojiSelector
